// Simple theme toggler. Reads/writes html[data-theme] and localStorage.
// No React context needed — DOM attribute is the source of truth.

const STORAGE_KEY = "gfwjc_theme";

export function getStoredTheme() {
  try {
    const t = localStorage.getItem(STORAGE_KEY);
    return t === "light" || t === "dark" ? t : null;
  } catch (_e) {
    return null;
  }
}

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "light") {
    root.setAttribute("data-theme", "light");
  } else {
    root.removeAttribute("data-theme");
  }
  try { localStorage.setItem(STORAGE_KEY, theme); } catch (_e) { /* ignore */ }
}

export function initTheme() {
  // Default to dark (site's brand). Only switch to light if user explicitly chose it.
  const stored = getStoredTheme();
  applyTheme(stored || "dark");
}

export function currentTheme() {
  return document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark";
}

export function toggleTheme() {
  const next = currentTheme() === "light" ? "dark" : "light";
  applyTheme(next);
  return next;
}
